import React, { useState, useEffect } from 'react'
import Form from '@/components/Form'
import useSiteContext from '@/context/SiteContext'
import { obtainAll, optInThirdParty } from '@/components/useFunctions'
import { getQueryParams, clearQueryParam } from 'react-use-query-param-string'
import { Optin } from '@/components/Form/Optin'

const DefaultSecondStep = ({ email }) => {
  return (
    <span className="block text-3xl leading-tight">
      Ahora elige los newsletters que quieras. Te llegarán todos a{' '}
      <i className="not-italic underline">{email}</i>.
      <Optin />
    </span>
  )
}

const Steps = ({
  Reveal,
  SecondStep = DefaultSecondStep,
  newsletters,
  btnColor,
  accentColor,
  bgColor,
  foregroundColor,
  labelText,
}) => {
  const {
    email,
    saveEmail,
    optin,
    setOptin,
    clearSubscriptions,
    addSubscriptions,
    setCanSubscribeToLT,
    setCanSubscribeToPC,
  } = useSiteContext()
  const [hasEmailSubscription, setHasEmailSubscription] = useState(false)

  const handleSubscriptionDataFromServer = (data, newsletters) => {
    console.log('handleSubscriptionDataFromServer', data, newsletters)
    if (data.length > 0) {
      const accumulator = []
      data.map(item => {
        const { name, status } = item
        const newsletter = newsletters.find(obj => obj.field === name)
        if (status && newsletter) {
          accumulator.push(newsletter)
        }
      })
      addSubscriptions(accumulator)
    }
  }

  useEffect(() => {
    const { email } = getQueryParams()
    if (
      email &&
      email.length > 0 &&
      email.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i)
    ) {
      saveEmail(email)
      clearQueryParam('email')
    }
  }, [])

  useEffect(() => {
    if (typeof window !== 'undefined') {
      if (email) {
        window.scrollTo({
          top: window.innerHeight / 2,
          behavior: 'smooth',
        })
      } else
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        })
    }
    if (email) {
      obtainAll(email)
        .then(res => {
          setHasEmailSubscription(true)
          console.log('data obtain all', res)
          const { suscriptor_lt, suscriptor_pc } = res
          if (suscriptor_lt) {
            setCanSubscribeToLT(true)
          }
          if (suscriptor_pc) {
            setCanSubscribeToPC(true)
          }
          handleSubscriptionDataFromServer(res.newsletters, newsletters)
          // setOptin('')
        })
        .catch(err => {
          console.log('email err', err)
        })
    }
  }, [email])

  useEffect(() => {
    if (email) {
      optInThirdParty(email, optin)
        .then(res => {
          console.log('optin res', res)
        })
        .catch(err => {
          console.log('optin err', err)
        })
    }
  }, [optin])

  return (
    <div>
      {email ? (
        <div className="">
          <div className="">
            <SecondStep email={email} />
            <p className="pb-0 font-sans text-sm text-left ">
              ¿No es tu correo electrónico?{' '}
              <a
                className="underline text-azul hover:text-black"
                href="#"
                onClick={e => {
                  saveEmail('')
                  clearSubscriptions('')
                  setOptin('')
                  setCanSubscribeToLT(false)
                  setCanSubscribeToPC(false)
                  e.preventDefault()
                }}>
                Ingresa otro
              </a>
            </p>
          </div>
          {hasEmailSubscription === false ? (
            <div className="flex justify-center">
              <div className="w-12 h-12 border-t-2 border-b-2 border-gray-900 rounded-full animate-spin"></div>
            </div>
          ) : (
            <>
              <Reveal email={email} />
            </>
          )}
        </div>
      ) : (
        <>
          <div className="md:w-9/12">
            {labelText && (
              <h6 className="mb-0 leading-tight ">
                <span className="block font-sans text-base leading-tight">
                  {labelText}
                </span>
              </h6>
            )}

            <Form
              btnColor={btnColor && btnColor.length > 0 ? btnColor : null}
              accentColor={
                accentColor && accentColor.length > 0 ? accentColor : null
              }
              bgColor={bgColor && bgColor.length > 0 ? bgColor : null}
              foregroundColor={
                foregroundColor && foregroundColor.length > 0
                  ? foregroundColor
                  : null
              }
            />
          </div>
        </>
      )}
    </div>
  )
}

export default Steps
